document.addEventListener("DOMContentLoaded", function () {
  initImageSizer();
  initVideoSlider();
  initPriorOffCanvas();
  customCookieBar();
});


function customCookieBar() {
	if ( $('.cookie-bar').length > 0 ) {
		if ( !Cookies.get('accepted_cookies') ) {
			$('.cookie-bar').fadeIn();
		}


		$('.cookie-bar__accept').on('click', function () {
			Cookies.set('accepted_cookies', 'true', {expires: 30});
			$('.cookie-bar').fadeOut();
		});
	}
}

function initImageSizer() {
  var images = document.querySelectorAll(".auto-sizing");
  if (images.length === 0) return;
  images.forEach(function (img) {
    var windowWidth = window.innerWidth;
    var imgWidth = img.clientWidth;
    var imgViewportWidth = Math.floor((imgWidth / windowWidth) * 100) + "vw";
    img.sizes = imgViewportWidth;
  });
}

function initVideoSlider() {
  var video = document.querySelector(".slider__video iframe");
  if (!video) return;
  coverViewport(video, true);
  window.addEventListener("resize", function () {
    coverViewport(video, true);
  });


  function coverViewport(element, scaleToParent) {
    if (typeof scaleToParent === "undefined") {
      scaleToParent = false;
    }

    var viewportWidth, viewportHeight;
    if (scaleToParent) {
      viewportWidth = element.parentElement.clientWidth;
      viewportHeight = element.parentElement.clientHeight;
    } else {
      viewportWidth = window.innerWidth;
      viewportHeight = window.innerHeight;
    }

    var elementWidth = element.getAttribute("width");
    var elementHeight = element.getAttribute("height");

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    // console.log('viewportHeigt: ', viewportHeight )
    // console.log('viewportWidth: ', viewportWidth )
    // console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);

    var newWidth = (elementWidth / elementHeight) * viewportHeight;
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
      // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
      // console.log('crop left and right');
      element.style.height = viewportHeight + "px";
      element.style.width = newWidth + "px";
      element.style.left = "-" + (newWidth - viewportWidth) / 2 + "px";
      element.style.top = "0";
    } else if (viewportRatio < videoRatio) {
      // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
      // console.log('crop top and bottom');
      element.style.width = viewportWidth + "px";
      element.style.height = newHeight + "px";
      element.style.left = "0";
      element.style.top = "-" + (newHeight - viewportHeight) / 2 + "px";
    } else {
      // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
      // console.log('no crop');
      element.style.height = viewportHeight + "px";
      element.style.width = viewportWidth + "px";
      element.style.left = "0";
      element.style.top = "0";
    }
  }

  // Make sure the slider always fills the whole screen
const $videoIframe = $('.slider__video iframe');
if ($('.slider__video iframe').length > 0) {
  $('.slider__inner').on('setPosition', function () {
    coverViewport($videoIframe, true);
  });

  $('.slider__inner').on('init', function () {
    coverViewport($videoIframe, true);
  });
}

}

function initPriorOffCanvas() {
  var menuContainer = document.querySelector("#offCanvas");
  var menuToggleBtns = document.querySelectorAll(
    ".header__open-off-canvas, .off-canvas__close"
  );

  var bookingContainer = document.querySelector("#booking");
  var bookingToggleBtns = document.querySelectorAll(
    ".header__open-booking, .booking__close"
  );

  var states = {
    isActiveMenu: false,
    isActiveBooking: false,
    toggleMenu: function () {
      this.isActiveMenu = !this.isActiveMenu;
    },
    toggleBooking: function () {
      this.isActiveBooking = !this.isActiveBooking;
    },
  };

  handleOffCanvasMenu(menuContainer, menuToggleBtns, states);
  handleOffCanvasBooking(bookingContainer, bookingToggleBtns, states);

  function handleOffCanvasMenu(container, toggleBtns, states) {
    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        states.toggleMenu();
        slideToggle(states.isActiveMenu, container);
      });
    });
  }

  function handleOffCanvasBooking(container, toggleBtns, states) {
    toggleBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        states.toggleBooking();
        revealToggle(states.isActiveBooking, container);
      });
    });
  }

  var slideToggle = function (state, container) {
    if (!state) {
      container.style.transform = "translateX(-100%)";
    } else {
      container.style.transform = "translateX(0)";
    }
  };

  var revealToggle = function (state, container) {
    if (!state) {
      container.classList.remove('active')
    } else {
      container.classList.add('active')
    }
  };
}
